import React, { Component, createRef } from 'react';
import FJSlider from '../slider/FJSlider';
import FJVolumeIcon from '../../../../assets/svg/volume.svg?react';
import FJMuteIcon from '../../../../assets/svg/volume-off.svg?react';
import Style from './FJPreviewVolumeContainer.module.less';
import FJUtil from '../../../../util/FJUtil.js';
import FJEvent from '../../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';

class FJPreviewVolumeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mute: false,
            isShowSlider: false,
        };
        this.slider = createRef();
        this.volumeOverlayRef = createRef();
    }

    hideVolume = () => {
        this.setState({ isShowSlider: false });
        FJUtil.removeEvent(document.body, 'mousedown', this.triggerEvent);
    };
    resetVolume = () => {
        this.slider.current.setProgress(1);
        this.setState({ mute: false });
    };

    getVolume = () => {
        return this.slider.current.getProgress();
    };

    _sliderDataChange = (value, progress) => {
        this.props.previewVolumeChang(progress);
        this._updateVolumeIcon(this.state.mute);
    };

    _updateVolumeIcon = preMute => {
        let mute = this.slider.current.getProgress() === 0;
        if (mute !== preMute) {
            this.setState({ mute: mute });
        }
    };
    _setVolumeValue = value => {
        this.slider.current.setValue(value, () => {
            this._updateVolumeIcon(this.state.mute);
        });
    };
    _setIsShowSlider = () => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        const { isShowSlider } = this.state;
        this.setState({ isShowSlider: !isShowSlider });
        if (!isShowSlider) {
            FJUtil.addEvent(document.body, 'mousedown', this.triggerEvent);
            FJUtil.addEvent(document.body, 'keydown', this.keymapChangeVolume);
        } else {
            FJUtil.removeEvent(document.body, 'mousedown', this.triggerEvent);
            FJUtil.removeEvent(document.body, 'keydown', this.keymapChangeVolume);
        }
    };

    triggerEvent = e => {
        let isInOverlayArea = FJUtil.isPanelArea(e, this.volumeOverlayRef.current);
        if (!isInOverlayArea) {
            this.hideVolume(e);
        }
    };

    keymapChangeVolume = e => {
        const progress = this.slider.current.getProgress();

        if (e.key === 'ArrowUp' || e.key === 'Up') {
            // 音量增加（支持 Windows 的 ArrowUp 和 Mac 的 Up）
            const newProgress = Math.round(Math.min(progress + 0.1, 1) * 10) / 10;
            this.slider.current.setProgress(newProgress, () => {
                this._sliderDataChange(null, newProgress);
            });
        } else if (e.key === 'ArrowDown' || e.key === 'Down') {
            // 音量减少（支持 Windows 的 ArrowDown 和 Mac 的 Down）
            const newProgress = Math.round(Math.max(progress - 0.1, 0) * 10) / 10;
            this.slider.current.setProgress(newProgress, () => {
                this._sliderDataChange(null, newProgress);
            });
        }
    };

    render() {
        const { isShowSlider } = this.state;
        return (
            <div className={Style.box}>
                <div
                    className={Style.volume_overlay}
                    style={{ visibility: isShowSlider ? 'visible' : 'hidden' }}
                    ref={this.volumeOverlayRef}
                >
                    <div className='c-preview-volume-popup-panel'>
                        <div className={Style.slider_container}>
                            <FJSlider
                                onChange={this._sliderDataChange}
                                vertical
                                useNative
                                ref={this.slider}
                                isMobile={this.props.isMobile}
                                defaultValue={1}
                                max={1}
                                handleClass={Style.handle}
                                railClass={Style.rail}
                                trackClass={Style.track}
                                sliderClass={Style.slider}
                            />
                        </div>
                    </div>
                </div>
                <div className={Style.btn_volume} onClick={this._setIsShowSlider}>
                    {this.state.mute ? <FJMuteIcon /> : <FJVolumeIcon />}
                </div>
            </div>
        );
    }
}

export default FJPreviewVolumeContainer;
